/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ArticleFooter/theme';

export const ArticleFooterTheme = theme;
